import { Button } from '@components/Button';
import { ReactElement } from 'react';

export interface ErrorProps {
	img: ReactElement<any, any>;
	title: string;
	description: ReactElement | string;
	btnText: string;
	btnCallback: () => void;
}

export default function Error({ img, title, description, btnText, btnCallback }: ErrorProps) {
	return (
		<div className='flex flex-col px-6 py-20 gap-6 bg-white w-screen h-screen justify-center items-center fixed top-0 left-0 text-center text-xl'>
			<div
				data-testid='error-img'
				className='w-[280px] h-[160px] tablet:w-[560px] tablet:h-[320px] tablet:mb-3 desktop:w-[448px] desktop:h-[256px] desktop:mb-12'>
				{img}
			</div>
			<h2 className='font-semibold'>{title}</h2>
			<div>
				<div className='w-100 pb-6 desktop:pb-12'>{description}</div>
			</div>
			<Button className='w-full tablet:w-[327px] mt-10' onClick={btnCallback}>
				{btnText}
			</Button>
		</div>
	);
}
